import React, { useEffect, useState } from 'react';
import { useField, useFormikContext } from 'formik';
import FieldWrapper from './FieldWrapper';
import { useTranslation } from 'react-i18next';
import { useModals } from '@/hooks/useModals';
import { MODALS } from '@/configs/modals';

const FormikPhotoUpload = (props) => {
  const {
    name,
    initName,
    label,
    className,
    fieldClassName,
    inputClassName,
    icon,
    accept="image/*",
    description,
    emptyImageUrl = '/images/no-user-image.jpg',
    uploadType = 'file', // file, base64
    isBtnRemove,
    ...restProps
  } = props;
  const { t } = useTranslation();
  // const [field, meta] = useField(name);
  const [fieldInit] = useField(initName);
  const [preview, setPreview] = useState(fieldInit?.value);
  const { setFieldValue } = useFormikContext();
  const textDescription = description || t('field_upload_text');

  useEffect(() => {
    setPreview(fieldInit?.value);
  }, [fieldInit?.value]);

  const handleChange = (event) => {
    const { target: { files } } = event;
    if (files.length) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
        if (uploadType === 'base64') {
          setFieldValue(name, reader.result);
        } else {
          setFieldValue(name, files[0]);
        }
      };
      reader.readAsDataURL(files[0]);
    }
  }

  const { modalOpen } = useModals();
  const handleClickRemove = (e) => {
    e.preventDefault();
    modalOpen(MODALS.confirm, {
      isOpen: true,
      text: t('photoUploader.confirm_delete'),
      isDeleteType: true,
      onOk: () => {
        setPreview(null);
        setFieldValue(name, "");
        setFieldValue(initName, "");
      },
    });
  };

  return (
    <FieldWrapper
      name={name}
      label={label}
      fieldClassName={fieldClassName}
      className={className}
    >
      <div className="photo-upload">
        <div className="photo-upload-preview">
          <img src={preview || emptyImageUrl} alt="" />
        </div>
        <input
          type="file"
          name={name}
          accept={accept}
          onChange={handleChange}
          className={`photo-upload-input ${inputClassName}`}
        />
        <span>{textDescription}</span>
        {isBtnRemove && !!preview && (
          <button
            className="photo-upload-btn-remove"
            title={t('photoUploader.btn_remove')}
            onClick={handleClickRemove}
            type="button"
          >
            ✕
          </button>
        )}
      </div>
    </FieldWrapper>
  );
};

export default FormikPhotoUpload;
